import Axios from "axios";
import { BASE_URL, SESSIONSTORAGE } from "../Constances/const";
export class Http {
    
    static _getHeader() {
        if(typeof window !== "undefined") {
            return {
                "Authorization": `Bearer ${window.sessionStorage.getItem(SESSIONSTORAGE.TOKEN) || ''}`,
            }
        }
        return {
            "Authorization": "Bearer"
        }
    }

    static get = (endPoint : string) => {
        const options = {
            headers: this._getHeader(),
        };
        return Axios.get(BASE_URL + endPoint, options);
    };

    static post = (endPoint : string, payload : object) => {
        return Axios.post(BASE_URL + endPoint, payload, {
            headers: this._getHeader(),
        });
    };
}
